export default class AccordionsHandler {
    private container: HTMLElement;
    private categoryWrapper: HTMLElement[] | null;

    constructor(container: HTMLElement) {
        this.container = container;
        this.categoryWrapper = [...this.container.querySelectorAll<HTMLElement>(".tabs-style")];

        this.init();
    }

    public init = async (): Promise<void> => {
        if (!this.container || !this.categoryWrapper) return;

        this.categoryWrapper.forEach((category) => {
            category.addEventListener("click", (e) => {
                this.setActiveElement(e);
            });
        });
    };

    private setActiveElement = async (e) => {
        const currentTarget = e.currentTarget as HTMLElement;
        const ActiveElement = this.container.querySelector(".tabs-style--active");
        const target = e.target as HTMLElement;

        this.removeAllClasses();

        currentTarget.classList.add("tabs-style--active");

        if (ActiveElement && target.classList.contains("tabs-style__button")) {
            ActiveElement.classList.remove("tabs-style--active");
        }
    };

    private removeAllClasses = () => {
        if (!this.categoryWrapper) return;

        this.categoryWrapper.forEach((category) => {
            category.classList.remove("tabs-style--active");
        });
    };
}
